export default "__VITE_ASSET__Bd_af7jE__"